<template>
  <div>
    <Header class="fixed top-0 left-0 right-0 z-50" />

    <main class="pt-24 pb-16">
      <div class="container mx-auto px-4 sm:px-6 max-w-4xl">
        <h1 class="text-4xl sm:text-5xl font-barlow-condensed font-medium text-brand mb-8 text-center">
          TERMS AND CONDITIONS
        </h1>

        <div class="prose prose-lg max-w-none">
          <p class="text-slate-600 mb-6 font-bold">
            Effective Date: {{ lastUpdated }}
          </p>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">1. Acceptance of Terms</h2>
            <p class="text-slate-600">
              By accessing or using <a href="https://MeditationCircle.com" class="font-bold">MeditationCircle.com</a>, you agree to be bound by these <span class="font-bold">Terms and Conditions</span>. If you do not agree to these terms, please discontinue use of the website. 
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">2. Who Can Use This Site</h2>
            <p class="text-slate-600">
              Anyone may access and use <a href="https://MeditationCircle.com" class="font-bold">MeditationCircle.com</a>.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">3. Permitted Use</h2>
            <p class="text-slate-600">
              The content on this site is provided for personal use and restrictions apply:
            </p>
            <ul class="list-disc pl-6 text-slate-600">
              <li>The content on this site is provided for <span class="font-bold">personal use only</span>.</li>
              <li>Redistribution or reproduction of content without permission is <span class="font-bold">strictly prohibited</span>.</li>
            </ul>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">4. Purchases & Refund Policy</h2>
            <p class="text-slate-600">
              All sales are digital and therefore final, and no refunds will be provided.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">5. User Registration & Responsibilities</h2>
            <p class="text-slate-600">
              Registration and user responsibilities include:
            </p>
            <ul class="list-disc pl-6 text-slate-600">
              <li>Users may <span class="font-bold">sign up through an opt-in form</span> to receive emails, updates, and access to guided meditations.</li>
              <li>Users must provide <span class="font-bold" >accurate and truthful</span> information when opting in.</li>
            </ul>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">6. Violation of Terms</h2>
            <p class="text-slate-600">
              If any user violates these terms, we reserve the right to:
            </p>
            <ul class="list-disc pl-6 text-slate-600">
              <li><span class="font-bold">Revoke access</span> to our guided meditation sessions.</li>
              <li><span class="font-bold">Block access</span> to our Zoom meetings.</li>
            </ul>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">7. Testimonials & User-Generated Content</h2>
            <p class="text-slate-600">
              We allow users to submit testimonials about their experience with our meditations. By submitting a testimonial, you <span class="font-bold">grant us permission to use and display it</span>  on our website and marketing materials.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">8. Governing Law</h2>
            <p class="text-slate-600">
             These Terms & Conditions are governed by the laws of <span class="font-bold">Arizona, USA</span>.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">9. Updates to These Terms</h2>
            <p class="text-slate-600">
             We may update these Terms & Conditions at any time. Changes will be <span class="font-bold">posted on this page</span>. For questions, contact <a href="mailto:support@meditationcircle.com" class="font-bold">support@meditationcircle.com</a>.
            </p>
          </section>
        </div>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Footer from '~/components/Footer.vue';
import Header from '~/components/Header.vue';

definePageMeta({
  name: 'terms'
});

const lastUpdated = ref('March 19, 2025');
</script>

<style scoped>
.prose h2 {
  margin-top: 1.5em;
  margin-bottom: 0.75em;
}

.prose p {
  margin-bottom: 1em;
  line-height: 1.7;
}
</style>
